import React from 'react';
import { destroy } from 'redux-form';
import { connect } from 'react-redux';
import history from 'config/history';
import { push } from 'react-router-redux';

import WithUser from 'shared/HOCs/WithUser';

import { buildUrlFromNextRedirect } from 'shared/utils/buildUrlFromNext';

import { withModal, FullScreenModal } from 'shared/components/Modals';
import SignUp from 'shared/components/Signup';
import { REGISTER, PROFILE_FORM } from 'shared/components/Signup/ducks';

import { MODALS } from 'global-constants';

class SignupModal extends React.Component {
  closeModal = () => {
    this.props.closeModal();
    this.props.destroy('registerForm');
    const nextURl = buildUrlFromNextRedirect(history.location.search);
    if (this.props.user && nextURl) this.props.push(nextURl);

    if (!this.props.user && nextURl)
      history.replace({
        search: ''
      });
  };

  render() {
    const { closeModal, data, currentStep } = this.props;

    const modalShouldHaveClose = [REGISTER, PROFILE_FORM].includes(currentStep);

    return (
      <FullScreenModal
        closeModal={this.closeModal}
        withClose={modalShouldHaveClose}>
        <SignUp closeModal={closeModal} data={data} />
      </FullScreenModal>
    );
  }
}

const mapStateToProps = state => {
  const { currentStep } = state.signup;

  return {
    currentStep
  };
};

const mapDispatchToProps = { destroy, push };

export default WithUser(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withModal(MODALS.SIGNUP)(SignupModal))
);
